// Map upsert methods (ES2024+) — needed for pdfjs-dist 5+ on older browsers (e.g. unpatched Chrome).
import 'map.prototype.getorinsert/auto';
import 'map.prototype.getorinsertcomputed/auto';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { CssBaseline, ThemeProvider } from '@mui/material';
import theme from './styles/theme';
import './index.css';
import { SnackbarContextProvider } from './store/snackbar-context';
import { ContentContextProvider } from './store/content-context';
import { BrowserRouter } from 'react-router-dom';
import { AuthContextProvider } from './store/auth-context';
import { CustomThemeProvider } from './store/theme-context';
import * as Sentry from '@sentry/react';

// Initialize Sentry only if DSN is provided (e.g. in production/staging)
if (process.env.REACT_APP_SENTRY_DSN) {
	Sentry.init({
		dsn: process.env.REACT_APP_SENTRY_DSN,
		environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
		release: process.env.REACT_APP_SENTRY_RELEASE,
		// Error monitoring only by default; you can increase this for performance tracing if needed
		tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '0'),
	});
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	// <React.StrictMode>
	<CustomThemeProvider>
		{/*<ThemeProvider theme={theme}>*/}
		<BrowserRouter>
			<SnackbarContextProvider>
				<AuthContextProvider>
					<ContentContextProvider>
						<CssBaseline />
						<Sentry.ErrorBoundary
							fallback={
								<div style={{ padding: 24 }}>
									<h2>Wystąpił nieoczekiwany błąd aplikacji.</h2>
									<p>Spróbuj odświeżyć stronę lub zalogować się ponownie.</p>
								</div>
							}
						>
							<App />
						</Sentry.ErrorBoundary>
					</ContentContextProvider>
				</AuthContextProvider>
			</SnackbarContextProvider>
		</BrowserRouter>
		{/*</ThemeProvider>*/}
	</CustomThemeProvider>,
	// </React.StrictMode>,
);
